import { render, staticRenderFns } from "./_ProductDetails.vue?vue&type=template&id=06570607&scoped=true&"
import script from "./_ProductDetails.vue?vue&type=script&lang=js&"
export * from "./_ProductDetails.vue?vue&type=script&lang=js&"
import style0 from "./_ProductDetails.vue?vue&type=style&index=0&id=06570607&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06570607",
  null
  
)

export default component.exports